import React from "react";
import { Container, Row, Col, Card, Button, ButtonGroup } from "reactstrap";
import { connect } from "react-redux";

import { Droppable, Draggable } from "react-beautiful-dnd";
import { renderElement } from "../../../../../helpers/renderElement";
import styled from "styled-components";
import { elementConstants } from "../../../../../../constants/cms/form/element/element.constants";

import { pageActions } from "../../../../../../store/actions/cms/page/page.action";
import { InnerElementWrapper } from "../../../../../components/element/Selected/InnerElementWrapper";
import { ElementOverlay } from "../../../../../components/element/Overlay/ElementOverlay";
import { DragHandleDistractor } from "../../../../../components/element/DragHandle/DragHandleDistractor";
import SystemLabel from "../../../../../../system/SystemLabel/SystemLabel";
import LinkManager from "../../../../../../navigation/LinkManager/LinkManager";

const DropArea = styled.div`
  background-color: ${(props) => props.isDraggingOver && "#20a8d85c"};
  padding-top: ${(props) => props.isDraggingOver && props.hasChildren && !props.isDropZoneDisabled && "200px"};
  padding-bottom: ${(props) => props.isDraggingOver && props.hasChildren && !props.isDropZoneDisabled && "200px"};

  padding: ${(props) => " 0px"};
  border: ${(props) => props.isDraggingOver && "1px dashed #20a8d8"};
`;

const DragContainer = styled.div`
  background-color: ${(props) => props.isDragging && "#e7f9ff"};
  background-color: ${(props) => props.backgroundColor};
`;

class PageContent extends React.Component {
  state = {
    template: null,
    formElements: null,
    isDropZoneDisabled: false,
    isMediaVaultOpen: false,
  };
  componentDidMount() {
    document.addEventListener("click", this.handleClick, false);
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.handleClick, false);
  }
  handleClick = (e) => {
    if (this.elementContainerRef.contains(e.target) || (this.props.asideEditorRef && this.props.asideEditorRef.contains(e.target))) {
      return;
    } else if (this.props.cms.deselectionBlocked) {
      return;
    } else {
      this.onDeselect();
    }
  };
  componentDidUpdate(prevProps) {
    if (prevProps.template !== this.props.template && this.props.template.template !== undefined) {
      const template = { ...this.props.template };
      this.setState({ ...this.state.template, template });
    }
    if (prevProps.form !== this.props.form && this.props.form !== undefined) {
      const { form } = this.props;
      const dataSource = form.formElements && [
        ...form.formElements
          .sort((a, b) => {
            let x = a.sortOrder;
            let y = b.sortOrder;
            return y < x ? 1 : y > x ? -1 : 0;
          })
          .filter((el) => el.page === form.currentPage && el.parentId === null),
      ];
      this.setState({ formElements: dataSource });
    }
  }
  onSelect = (element) => {
    const { dispatch } = this.props;
    dispatch(pageActions.select(element));
  };
  onDelete = (element) => {
    const { dispatch } = this.props;
    dispatch(pageActions.remove(element));
  };
  onDeselect = () => {
    const { dispatch } = this.props;
    dispatch(pageActions.deselect());
  };
  disableDropZone = (isDisabled) => {
    this.setState({ isDropZoneDisabled: isDisabled });
  };
  sortElements = () => {
    const { currentPage, pageElements } = this.props.page;
    if (pageElements === undefined || pageElements.length < 1) {
      return [];
    }
    let sortOrder = 0;
    let sortedElements = Array.from(pageElements);
    sortedElements = sortedElements
      .filter((el) => {
        return el.page === currentPage && el.parentId === null;
      })
      .sort((a, b) => {
        let x = a.sortOrder;
        let y = b.sortOrder;
        return y < x ? 1 : y > x ? -1 : 0;
      })
      .map((v) => {
        v.sortOrder = sortOrder;
        sortOrder++;
        return v;
      });

    console.table(sortedElements);
    return sortedElements;
  };
  isImage = (element) => {
    let style = { height: "auto" };
    /*  if (element.type === elementConstants.CONTENT && element.props.type === 'IMG') {
       style.height = '200px';
     } */
    return style;
  };
  providePlaceholder = (elements, placeholder) => {
    if (elements.length < 1 && !this.state.isDropZoneDisabled) {
      return (
        <div
          style={{
            height: "200px",
            border: "2px dotted #0000000f",
            textAlign: "center",
          }}
        >
          {placeholder}
        </div>
      );
    } else {
      return <div style={{}}>{placeholder}</div>;
    }
  };
  render() {
    const { page } = this.props;
    const { template } = this.props.template;
    const sortedElements = this.sortElements();
    return (
      <div className="target">
        {/*         <LinkManager /> */}
        <div /* onClick={() => this.onDeselect()} c */ className="animated fadeIn">
          <div ref={(r) => (this.elementContainerRef = r)}>
            <Droppable isDropDisabled={this.state.isDropZoneDisabled} droppableId="content">
              {(provided, snapshot) => {
                return (
                  <DropArea {...provided.droppableProps} isDraggingOver={snapshot.isDraggingOver} isDropZoneDisabled={this.state.isDropZoneDisabled} ref={provided.innerRef}>
                    {sortedElements.map((el, index) => {
                      return (
                        <div className="animated fadeIn" key={index}>
                          <Draggable key={index} draggableId={el.contentId} index={index}>
                            {(provided, snapshot) => (
                              <DragContainer {...provided.draggableProps} {...this.props} ref={provided.innerRef} isDragging={snapshot.isDragging} hasChildren={true}>
                                <div style={this.isImage(el)} className="element-container">
                                  <Row
                                    style={{
                                      width: "100%",
                                      display: "flex",
                                      marginLeft: "0px",
                                    }}
                                  >
                                    <InnerElementWrapper selectedContainer={page.selectedContainer} targetElement={el} selectedElement={page.selectedElement}>
                                      <Col
                                        style={{
                                          maxWidth: "100%",
                                          backgroundColor: "inherit",
                                          padding: "0px",
                                          /*   display: 'inline-flex' */
                                        }}
                                        onClick={() => this.onSelect(el)}
                                      >
                                        {renderElement(el.type, el, this.disableDropZone)}
                                      </Col>

                                      <ElementOverlay
                                        selectedContainer={page.selectedContainer}
                                        targetElement={el}
                                        dragHandleProps={provided.dragHandleProps}
                                        selectedElement={page.selectedElement}
                                        onDelete={this.onDelete}
                                      />
                                    </InnerElementWrapper>
                                    <DragHandleDistractor dragHandleProps={provided.dragHandleProps} />
                                  </Row>
                                </div>
                              </DragContainer>
                            )}
                          </Draggable>
                          {/*  {(sortedElements[index + 1] !== undefined && sortedElements[index + 1].type) ||
                              el.type === elementConstants.CONTAINER ? <div style={{ height: '25px', width: '100%' }} /> : null} */}
                        </div>
                      );
                    })}
                    {this.providePlaceholder(sortedElements, provided.placeholder)}
                  </DropArea>
                );
              }}
            </Droppable>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    alert: state.alert,
    form: state.form,
    template: state.template,
    page: state.page,
    cms: state.cms,
  };
}

export default connect(mapStateToProps)(PageContent);
